import { RewardsIconSchema } from "@apps/rewards/schemas/RewardsIconSchema";
import { DiscountRewardSchema } from "@apps/rewards/schemas/RewardsRewardSchemas/RewardsDiscountRewardSchema";
import { FreeProductRewardSchema } from "@apps/rewards/schemas/RewardsRewardSchemas/RewardsFreeProductRewardSchema";
import { GiftCardRewardSchema } from "@apps/rewards/schemas/RewardsRewardSchemas/RewardsGiftCardRewardSchema";
import { PointsRewardSchema } from "@apps/rewards/schemas/RewardsRewardSchemas/RewardsPointsRewardSchema";
import {
    array,
    boolean,
    enums,
    nullable,
    number,
    object,
    omit,
    string,
    union,
} from "superstruct";

import { VIP_TIERS_CONDITION_TYPES } from "../constants";

export const VipTiersRewardSchema = union([
    PointsRewardSchema,
    omit(DiscountRewardSchema, ["discountCode"]),
    omit(GiftCardRewardSchema, ["code", "balance"]),
    FreeProductRewardSchema,
]);

export const VipTierSchema = object({
    id: number(),
    title: string(),
    description: nullable(string()),
    perks: array(string()),
    pointsMultiplier: nullable(number()),
    image: nullable(RewardsIconSchema),
    condition: enums(Object.values(VIP_TIERS_CONDITION_TYPES)),
    conditionValue: number(),
    rewarding: nullable(VipTiersRewardSchema),
    isDefault: boolean(),
});

export const VipTiersResponseSchema = object({
    tiers: array(VipTierSchema),
});

export const VipTierProgressResponseSchema = object({
    progress: nullable(number()),
});
